import { TestAdapter } from '@oracle/oraclejet-testing/UNSAFE_TestAdapter';

export class ProgressButtonAdapter extends TestAdapter {
  /**
   * Click on the button
   * @returns
   */
  async doAction() {
    const driver = this.getTestDriver();
    return driver.click(await this.getElement());
  }
}
